jQuery.noConflict(),
( function( $ ) {
	const $header = $( '.site-header' ),
		$headerSearchToggle = $( '.toggle-header-search' ),
		$headerSearchWrap = $( '#header-search' ),
		$headerSearchInput = $headerSearchWrap.find( 'input[type="search"]' );

	function showSearch() {
		$header.addClass( 'search-visible' ), $headerSearchWrap.fadeIn( 'fast' ).find( 'input[type="search"]' ).focus(), $headerSearchToggle.attr( 'aria-expanded', ! 0 );
	}

	function hideSearch() {
		$headerSearchWrap.fadeOut( 'fast' ).parents( '.site-header' ).removeClass( 'search-visible' ), $headerSearchToggle.attr( 'aria-expanded', ! 1 );
	}
	$( window ).scroll( function() {

	} ), $headerSearchToggle.on( 'click', function( event ) {
		event.preventDefault(), ( $( this ).hasClass( 'close' ) ? hideSearch : showSearch )();
	} ), $headerSearchToggle.on( 'keydown', function( event ) {
		9 === event.keyCode && ! $header.hasClass( 'search-visible' ) || ( event.preventDefault(), ( function( event ) {
			13 !== event.keyCode && 32 !== event.keyCode || ( event.preventDefault(), ( $( event.target ).hasClass( 'close' ) ? hideSearch : showSearch )() );
		}( event ) ) );
	} ), $headerSearchInput.on( 'keydown', function( event ) {
		9 !== event.keyCode && 27 !== event.keyCode || hideSearch( event.target );
	} ), $headerSearchInput.on( 'blur', hideSearch );
}
( jQuery ) );

( function( $ ) {
	var navigation = navigation || {};
	navigation.mobileMenu = {
		init() {
			$( '.menu-toggle' ).on( 'click', function() {
				navigation.mobileMenu.toggleMenu();
			} ), $( '.sub-nav-toggle' ).on( 'click', function() {
				navigation.mobileMenu.toggleSubMenu( $( this ) );
			} ), $( window ).on( 'load', function() {
				navigation.mobileMenu.checkSubMenuActive();
			} );
		},
		toggleMenu() {
			$( 'body' ).hasClass( 'showing-mobile-menu' ) ? navigation.mobileMenu.hideMenu() : navigation.mobileMenu.showMenu();
		},
		showMenu() {
			$( '.menu-toggle' ).addClass( 'active' ), $( '.menu-toggle' ).attr( 'aria-expanded', 'true' ), $( '.main-navigation' ).addClass( 'visible' ), $( 'body' ).addClass( 'showing-mobile-menu lock-scroll' );
		},
		hideMenu() {
			$( '.menu-toggle' ).removeClass( 'active' ), $( '.menu-toggle' ).attr( 'aria-expanded', 'false' ), $( '.main-navigation' ).removeClass( 'visible' ), $( 'body' ).removeClass( 'showing-mobile-menu lock-scroll' );
		},
		toggleSubMenu( $subNavToggle ) {
			const $subMenu = $subNavToggle.parent( '.menu-toggle-wrapper' ).next( '.sub-menu' );
			$subNavToggle.toggleClass( 'active' ), $subMenu.slideToggle( 400 );
		},
		checkSubMenuActive() {
			const $currentMenuItem = $( '.main-navigation ul li.current-menu-item' );
			$currentMenuItem.length && $currentMenuItem.parents( 'li.current_page_ancestor' ).each( function() {
				$( this ).children( '.menu-toggle-wrapper' ).children( '.sub-nav-toggle' ).addClass( 'active' ), $( this ).children( '.sub-menu' ).show();
			} );
		},
	}, $( document ).ready( function() {
		navigation.mobileMenu.init();
	} );
}
( jQuery ) );

document.addEventListener( 'facetwp-loaded', function() {
	const tpl = fUtil( '.facetwp-template' );
	if ( '' != FWP.buildQueryString() ) {
		tpl.removeClass( 'facetwp-hidden' );
	} else {
		tpl.addClass( 'facetwp-hidden' );
	}
} );
